// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"331f785e","659":"2058e5f6","687":"06912ee5"}[chunkId] + ".chunk.js";
};